export var ScreeningStatus;
(function (ScreeningStatus) {
    ScreeningStatus["ScreeningProcessing"] = "PROCESSING";
    ScreeningStatus["ScreeningCompleted"] = "COMPLETED";
    ScreeningStatus["ScreeningError"] = "ERROR";
})(ScreeningStatus || (ScreeningStatus = {}));
